module.exports = __webpack_public_path__ + "static/img/plus-circle.76600e6a.svg";